// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5nkM5","col":"styles_col__oI0sN"};